import courseListV2, { CourseV2ListParams } from "@/getinfo-api/courseV2";
import { courseApi } from "@/getinfo-api";
import { MainList } from "@/classes/MainList";
import { Course as ICourse } from "@/api/models/course";

export class CoursesListClass extends MainList {
  params: CourseV2ListParams = {
    companyId: this.companyId,
    limit: 30,
    offset: 0
  };

  constructor(params?: any, selectedValue?: string | undefined) {
    super();
    this.method = courseListV2;
    this.params = { ...this.params, ...params };
    this.baseParams = this.params;
    // this.dataLabel = "courses";
    if (selectedValue) {
      this.singleMethod = () => courseApi.Course.getCourse(selectedValue);
      this.single();
    }
    this.list();
  }

  search(value: string) {
    this.params.title = value;
    this.list();
  }

  get courses(): Array<ICourse> {
    return this.listItems;
  }
}
